// TODO: add common locale variations
let compMod = angular.module('date.constants', []).constant('DATE_FRMT', {
	US: {
		NUMERICAL: 'MM/dd/yyyy',
		SPELLED_OUT: 'MMM d, yyyy',
		SPELLED_OUT_AT: "MMM d, yyyy' at ' h:mm a",
	},
	CA: {
		NUMERICAL: 'MM/dd/yyyy',
		SPELLED_OUT: 'd MMM, yyyy',
		SPELLED_OUT_AT: "d MMM, yyyy' at ' h:mm a",
	},
	ES: {
		NUMERICAL: 'dd/MM/yyyy',
		SPELLED_OUT: 'd MMM yyyy',
		SPELLED_OUT_AT: 'd MMM yyyy h:mm a',
	},
});
export default (compMod = compMod.name);
